// extracted by mini-css-extract-plugin
module.exports = {"disableSelect":"src-hellospa-common-hooks__disableSelect--2mcXM"};